import React, { PropTypes } from 'react';
import DataTable from "../../DataTable";
import { inject, observer } from "mobx-react/index";
import Spinner from "../../Spinner";
import { getDisplayDate } from "../../../libs/date";

@inject('parameterStore', 'qcRuleStore', 'qcCheckStore', 'qcFlagStore', 'stationStore')
@observer
class ParameterQCList extends React.Component {
  static contextTypes = {
    notify: PropTypes.object.isRequired,
  };

  columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name', searchable: true },
    { key: 'parameter.name', label: 'Parameter', searchable: true },
    // {key: 'qc_rule.description', label: 'QC Rule'},
    { key: 'interval', label: 'Interval' },
    // {key: 'observation_id', label: 'Observation ID'},
    { key: 'timestamp', label: 'Timestamp' },
    { key: 'status', label: 'Status' },
  ];

  slug = 'qc/check';

  componentWillMount() {
    const { qcCheckStore, parameterStore, qcRuleStore } = this.props;
    if (!qcCheckStore.items.length && !qcCheckStore.isLoading) qcCheckStore.fetchItems();
    if (!parameterStore.items.length && !parameterStore.isLoading) parameterStore.fetchItems();
    if (!qcRuleStore.items.length && !qcRuleStore.isLoading) qcRuleStore.fetchItems();
  }

  handleDelete = (idOrIds) => {
    const { notify } = this.context;
    console.log('handleDelete', idOrIds);
    this.props.qcCheckStore.removeItems(idOrIds)
      .then(() => {
        notify.success();
      })
      .catch(notify.error);
  };

  render() {
    const { qcCheckStore, parameterStore, qcRuleStore, stationStore } = this.props;
    if (qcCheckStore.isLoading || parameterStore.isLoading || qcRuleStore.isLoading || qcRuleStore.isLoading || stationStore.isLoading) return <Spinner />;

    let data = qcCheckStore.items.map(item => (Object.assign({}, item, {
      parameter: parameterStore.findById(item.parameter_id),
      // qc_rule: qcRuleStore.findById(item.qc_rule_id),
      interval: qcCheckStore.interpretCronFormat(item.interval),
      // status: <i className='fa fa-circle' style={{color: item.status ? '#00bf00' : '#ff0000'}} data-toggle="tooltip" title={item.status ? 'Enabled' : 'Disabled'}/>
      observation_id: item.observation_id,
      timestamp: item.timestamp ? getDisplayDate(item.timestamp) : '',
      status: <i className='fa fa-circle' style={{ color: item.status ? 'green' : 'red' }} data-toggle="tooltip" title={item.status ? 'Enabled' : 'Disabled'} />
    })));

    // let dataWithTimestamp = data.filter(item => !!item.timestamp).sort((a,b) => a.name < b.name ? -1 : 1);
    // let dataWithoutTimestamp = data.filter(item => !item.timestamp).sort((a,b) => a.name > b.name ? -1 : 1);

    return (
      <div>
        <DataTable
          data={data}
          columns={this.columns}
          slug={this.slug}
          onDelete={this.handleDelete}
          resource='qc-check'
          allowAdd
          allowEdit
          allowDelete
        />
        {this.props.children}
      </div>
    );
  }
}

export default ParameterQCList;


// WEBPACK FOOTER //
// ./src/components/QCRule/ParameterQC/ParameterQCList.js